// extracted by mini-css-extract-plugin
module.exports = {"counterWrapper":"styles-module__counterWrapper___28v-H","quantityInput":"styles-module__quantityInput___2-yS0"};